import { FlexGap, PageHeader, StackHorizontal, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { MailboxActions } from './MailboxActions';

function MailboxSearchHeader() {
	const { t } = useTranslation();

	return (
		<PageHeader title={t('mailboxes.search.title')} secondaryHeader extraClass='mailbox-page-header'>
			<StackHorizontal gap={FlexGap.Small}>
				<MailboxActions />
			</StackHorizontal>
		</PageHeader>
	);
}

export { MailboxSearchHeader };
